export const FormatDate = (isoString) => {
    const date = new Date(isoString); 
    const day = date.getDate().toString().padStart(2, '0'); 
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    const year = date.getFullYear();
    return `${day}/${month}/${year}`; 
};


export const FormatDateHours = (isoString) => {
    const date = new Date(isoString); 
    const day = date.getDate().toString().padStart(2, '0'); 
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const addDaysToDate = (dateString, days)  => {
    const date = new Date(dateString);
    date.setDate(date.getDate() + days);
    return FormatDate(date);
  }
